import React from 'react';

/**
 * Benchmarks Tab Component
 */
export const BenchmarksTab = ({ benchmarks }) => (
  <div className="space-y-6">
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700">
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Industry Benchmarking Analysis</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="text-center p-4 bg-blue-50 dark:bg-blue-900/30 rounded-lg">
          <div className="text-2xl font-bold text-blue-600 dark:text-blue-400 mb-2">
            {benchmarks?.facility_percentile || 65}th
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-400">Industry Percentile</div>
        </div>
        <div className="text-center p-4 bg-emerald-50 dark:bg-emerald-900/30 rounded-lg">
          <div className="text-2xl font-bold text-emerald-600 dark:text-emerald-400 mb-2">
            ${(benchmarks?.industry_average_savings || 45000).toLocaleString()}
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-400">Industry Average Savings</div>
        </div>
        <div className="text-center p-4 bg-purple-50 dark:bg-purple-900/30 rounded-lg">
          <div className="text-2xl font-bold text-purple-600 dark:text-purple-400 mb-2">
            ${(benchmarks?.top_quartile_savings || 75000).toLocaleString()}
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-400">Top Quartile Savings</div>
        </div>
      </div>
      <div className="mt-6 p-4 bg-gray-50 dark:bg-gray-900 rounded-lg">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong>Benchmark Analysis:</strong> {benchmarks?.benchmark_model || 'Professional IAC Database + ARC Integration'}
        </p>
      </div>
    </div>
  </div>
);

